import { PlainConfirmModal, type PlainConfirmModalProps } from './plain-confirm-modal'
import { PlainConfirm } from './plain-confirm'


export default PlainConfirmModal
export { PlainConfirm }
export type { PlainConfirmModalProps }
